var exports = {
  "DD": "x28a7bf27--935031--title",
  "Tg": "x28a7bf27--935031--advantages",
  "A_": "x28a7bf27--935031--advantage",
  "ME": "x28a7bf27--935031--sub-title",
};

module.exports = exports;
